import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: [],
};

const constentArraySlice = createSlice({
  name: "score",
  initialState,
  reducers: {
    contentArray: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { contentArray } = constentArraySlice.actions;
export default constentArraySlice.reducer;
